import { NgModule } from '@angular/core';

import { GoogleSsoSettingsComponent } from './google-sso.settings.component';
import { GoogleSsoService }           from './google-sso.service';
import { SharedModule }               from '../shared/shared.module';

@NgModule({
  declarations: [
    GoogleSsoSettingsComponent
  ],
  entryComponents: [
    GoogleSsoSettingsComponent
  ],
  exports: [
    GoogleSsoSettingsComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    GoogleSsoService
  ]
})
export class GoogleSsoModule {}
